import React, { Component } from 'react';
import '../public/less/forms.less';
import '../public/less/doctorAdvice.less';
import '../public/less/popup.less';
import { CheckBox } from './common/forms';
import { LabelWithArrow, Load } from './common/basic';
import ReactDom from 'react-dom';
import axios from 'axios';
import { Radio } from 'react-bootstrap';
import dateHelper from '../helpers/date';

import PatientSmallTitle from './doctorAdvice/PatientSmallTitle';
import TrearmentBoxOption from './doctorAdvice/TrearmentBoxOption';
import MeasurementBox from './doctorAdvice/MeasurementBox';
import ScheduleBoxOption from './doctorAdvice/ScheduleBoxOption';
import ScheduleComponent from './doctorAdvice/ScheduleComponent';
import TrearmentBox from './doctorAdvice/TrearmentBox';

var isSubmitPossible = false;

module.exports = class doctorAdvice extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            Comment: '',
            EMT: {
                PowerLevel: 'LOW',
                Duration: 1,
                Order: 0
            },
            RF: {
                PowerLevel: 'LOW',
                Duration: 1,
                Order: 1
            },
            LLLT: {
                PowerLevel658: 'LOW',
                PowerLevel852: 'LOW',
                Duration: 1,
                Wave: '658',
                Order: 1
            },
            Measurement: {},
            imageUrl: '',
            isError: false
        };

        this.LLLTWaveChange = this.LLLTWaveChange.bind(this);
        this.saveForm = this.saveForm.bind(this);
        this.updateDetails = this.updateDetails.bind(this);
        this.changeComment = this.changeComment.bind(this);
    }

    componentDidMount() {
        this
            ._loading
            .Show();
        axios
            .get("/data/doctorAdvice/" + this.props.params.userID)
            .then(function(data) {
                this
                    ._loading
                    .Hide();

                this.setState({
                    Comment: data.data.Comment,
                    imageUrl: data.data.image.url
                });
                if (data.data.RF != null) {
                    this.setState({
                        RF: data.data.RF
                    });
                }
                if (data.data.EMT != null) {
                    this.setState({
                        EMT: data.data.EMT,
                    });
                }
                if (data.data.LLLT != null) {
                    this.setState({
                        LLLT: data.data.LLLT,
                    });
                }
                if (data.data.Measurement != null) {
                    this.setState({
                        Measurement: data.data.Measurement,
                    });
                }

                // LLLT
                if (data.data.LLLT && data.data.LLLT != null) {
                    this.LLLTBox.changeValues(data.data.LLLT.OrderID + 1, data.data.LLLT.IsActive);
                    this.LLLTDuration.changeValue(data.data.LLLT.Duration);
                    this.LLLTPower658.changeValue(data.data.LLLT.PowerLevel658);
                    this.LLLTPower852.changeValue(data.data.LLLT.PowerLevel852);
                    this.LLLTWave.changeValue(data.data.LLLT.Wave);
                    this.LLLTRepeat.changeValues(data.data.LLLT.Repeat);
                }

                // EMT
                if (data.data.EMT && data.data.EMT != null) {
                    this.EMTBox.changeValues(data.data.EMT.OrderID + 1, data.data.EMT.IsActive);
                    this.EMTPower.changeValue(data.data.EMT.PowerLevel);
                    this.EMTDuration.changeValue(data.data.EMT.Duration);
                    this.EMTRepeat.changeValues(data.data.EMT.Repeat);
                }
                // RF
                if (data.data.RF && data.data.RF != null) {
                    this.RFBox.changeValues(data.data.RF.OrderID + 1, data.data.RF.IsActive);
                    this.RFPower.changeValue(data.data.RF.PowerLevel);
                    this.RFDuration.changeValue(data.data.RF.Duration);
                    this.RFRepeat.changeValues(data.data.RF.Repeat);
                }

                // Measurements
                if (data.data.Measurement && data.data.Measurement != null) {
                    this.MeasurementBox.changeValues(data.data.Measurement.IsActive)
                    this.MeasurementRepeat.changeValues(data.data.Measurement.Repeat);
                }

            }.bind(this))
            .catch(function(error) {
                if (error.response && error.response.data == "No permissions") {
                    window.location.replace("/login");
                }
                console.log(error);
            });
    }

    beforeSubmit(evt) {
        if (!isSubmitPossible) {
            evt.preventDefault();
        }
    }

    saveForm() {
        var orders = [];

        if (this.state.RF.IsActive) {
            orders.push(this.state.RF.OrderID);
        }
        if (this.state.LLLT.IsActive) {
            orders.push(this.state.LLLT.OrderID);
        }
        if (this.state.EMT.IsActive) {
            orders.push(this.state.EMT.OrderID);
        }

        if (orders.length == 2 && (orders[0] == orders[1] || orders.indexOf(2) != -1)) {
            isSubmitPossible = false;
        }
        else if (orders.length == 3 && (orders[0] == orders[1] || orders[1] == orders[2] || orders[0] == orders[2])) {
            isSubmitPossible = false;
        }
        else {
             this.setState({ isError: false });
            isSubmitPossible = true;
            this._submit.click();
        }

        if (!isSubmitPossible) {
            this.setState({ isError: true });
            this._error.focus();
        }
    }

    LLLTWaveChange(value) {
        var LLLT = this.state.LLLT;
        LLLT.Wave = value;
        this.setState({ LLLT: LLLT });
    }

    changeComment(evt) {
        this.setState({
            Comment: evt.target.value
        });
    }

    updateDetails(isActive, order, type) {
        if (type == "LLLT") {
            var LLLT = this.state.LLLT;
            LLLT.OrderID = order - 1;
            LLLT.IsActive = isActive;
            this.setState({ LLLT: LLLT });
        }
        else if (type == "RF") {
            var RF = this.state.RF;
            RF.OrderID = order - 1;
            RF.IsActive = isActive;
            this.setState({ RF: RF });
        }
        else if (type == "EMT") {
            var EMT = this.state.EMT;
            EMT.OrderID = order - 1;
            EMT.IsActive = isActive;
            this.setState({ EMT: EMT });
        }
    }

    render() {
        var patientID = this.props.params.userID;
        var durationOptions = [];
        for (var i = 1; i <= 20; i++) {
            durationOptions.push({ key: i, name: i });
        }
        var durationSelected = 10;
        var LLLTDuration = this.state.LLLT.Duration;

        var waveOptionsLLLT = [{ key: '658', name: '658' }, { key: '852', name: '852' }, { key: 'BOTH', name: '658+852' }];
        var LLLTWave = this.state.LLLT.Wave;

        var waveSelected = 3;

        var powerOptions = [{ key: 'LOW', name: 'LOW' }, { key: 'MED', name: 'MED' }, { key: 'HIGH', name: 'HIGH' }];
        var powerSelected = 2;

        var LLLTPower658 = this.state.LLLT.PowerLevel658;
        var LLLTPower852 = this.state.LLLT.PowerLevel852;

        var postUrl = "/doctorAdvice/" + patientID;
        var imageUrl = this.state.imageUrl ? this.state.imageUrl : '/gallery/register/icon_expert_female.png';

        var selectedWave = this.state.LLLT.Wave;
        var LLLTPower658Class = (selectedWave == '658' || selectedWave == 'BOTH') ? 'Power grey' : 'hidden';
        var LLLTPower852Class = (selectedWave == '852') ? 'Power grey' : (selectedWave == 'BOTH' ? 'Power white' : 'hidden');
        var LLLTDurationClass = (selectedWave == 'BOTH' ? "Duration grey" : "Duration white");
        var LLLTRepeatClass = (selectedWave == 'BOTH' ? "Schedule white" : "Schedule grey");

        var errorClass = this.state.isError == true ? "error" : "hidden";
        return (
            <div>
                <Load
                    ref={(loading) => {
                        this._loading = loading;
                    }} />
                <PatientSmallTitle imgUrl={imageUrl} patientID={this.props.params.userID} />

                <form action={postUrl} method="POST" onSubmit={this.beforeSubmit}>
                    <div className='container'>

                        <h3 className='padding30'>Set Treatment Values and Schedule</h3>
                        <div className='row'>
                            <div className='col-md-4'>

                                <TrearmentBox ID="LLLT" name="LLLT" data={this.state.LLLT} ref={(LLLTBox) => { this.LLLTBox = LLLTBox; }} updateDetails={this.updateDetails}>
                                    <TrearmentBoxOption options={waveOptionsLLLT} className="Wave white" selected={LLLTWave} view="LLLTWave" Title="Wave" imgUrl="/gallery/doctorAdvice/wave_icon.png" ref={(LLLTWave) => { this.LLLTWave = LLLTWave; }} onChange={this.LLLTWaveChange} />
                                    <TrearmentBoxOption options={powerOptions} className={LLLTPower658Class} selected={LLLTPower658} view="LLLTPower658" Title="Power" BracketTitle="(658)" imgUrl="/gallery/doctorAdvice/power_icon.png" ref={(LLLTPower658) => { this.LLLTPower658 = LLLTPower658; }} />
                                    <TrearmentBoxOption options={powerOptions} className={LLLTPower852Class} selected={LLLTPower852} view="LLLTPower852" Title="Power" BracketTitle="(852)" imgUrl="/gallery/doctorAdvice/power_icon.png" ref={(LLLTPower852) => { this.LLLTPower852 = LLLTPower852; }} />
                                    <TrearmentBoxOption options={durationOptions} className={LLLTDurationClass} selected={LLLTDuration} view="LLLTDuration" Title="Duration" imgUrl="/gallery/doctorAdvice/duration_icon.png" ref={(LLLTDuration) => { this.LLLTDuration = LLLTDuration; }} />
                                    <ScheduleBoxOption className={LLLTRepeatClass} ID='LLLT' data={this.state.LLLT.Repeat} ref={(LLLTRepeat) => { this.LLLTRepeat = LLLTRepeat; }} />
                                </TrearmentBox>
                            </div>
                            <div className='col-md-4'>
                                <TrearmentBox ID="EMT" name="ELP" data={this.state.EMT} ref={(EMTBox) => { this.EMTBox = EMTBox; }} updateDetails={this.updateDetails}>
                                    <TrearmentBoxOption options={powerOptions} className="Power white" selected={powerSelected} view="EMTPower" Title="Power" imgUrl="/gallery/doctorAdvice/power_icon.png" ref={(EMTPower) => { this.EMTPower = EMTPower; }} />
                                    <TrearmentBoxOption options={durationOptions} className="Duration grey" selected={durationSelected} view="EMTDuration" Title="Duration" imgUrl="/gallery/doctorAdvice/duration_icon.png" ref={(EMTDuration) => { this.EMTDuration = EMTDuration; }} />
                                    <ScheduleBoxOption className="Schedule white" ID='EMT' ref={(EMTRepeat) => { this.EMTRepeat = EMTRepeat; }} />
                                </TrearmentBox>
                            </div>
                            <div className='col-md-4'>
                                <TrearmentBox ID="RF" name="RF" data={this.state.RF} ref={(RFBox) => { this.RFBox = RFBox; }} updateDetails={this.updateDetails}>
                                    <TrearmentBoxOption options={powerOptions} className="Power white" selected={powerSelected} view="RFPower" Title="Power" imgUrl="/gallery/doctorAdvice/power_icon.png" ref={(RFPower) => { this.RFPower = RFPower; }} />
                                    <TrearmentBoxOption options={durationOptions} className="Duration grey" selected={durationSelected} view="RFDuration" Title="Duration" imgUrl="/gallery/doctorAdvice/duration_icon.png" ref={(RFDuration) => { this.RFDuration = RFDuration; }} />
                                    <ScheduleBoxOption className="Schedule white" ID='RF' ref={(RFRepeat) => { this.RFRepeat = RFRepeat; }} />
                                </TrearmentBox>
                            </div>
                        </div>
                        <hr />
                        <div className='row'>
                            <div className='col-md-4'>
                                <h3 className='padding30'>Set Measurement Schedule</h3>
                                <MeasurementBox data={this.state.Measurement} ID="Measurements" ref={(MeasurementBox) => { this.MeasurementBox = MeasurementBox; }}>
                                    <ScheduleBoxOption className="Schedule grey" ID='Measurements' ref={(MeasurementRepeat) => { this.MeasurementRepeat = MeasurementRepeat; }} />
                                </MeasurementBox>
                            </div>
                        </div>
                        <hr />
                        <div className='Comment'>
                            <div className="form-group">
                                <div className={errorClass} ref={(error) => { this._error = error }}>Order is not correct</div>
                                <div className='row'>
                                    <div className='col-xs-8'>
                                        <input type='text' id="comment" name="comment" placeholder='Write a comment...' className="form-control" value={this.state.Comment} onChange={this.changeComment} />
                                    </div>
                                    <div className='col-xs-4'>
                                        <button className='btnSave' onClick={this.saveForm}>SAVE CHANGES</button>
                                        <button className='btnSend'>SEND TO PATIENT</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <input
                        type='submit'
                        className='hidden'
                        ref={(submit) => {
                            this._submit = submit;
                        }} />
                </form>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// ./modules/doctorAdvice.jsx